<template>
  <div class="chart-container" :class="{ 'chart-container--embedded': embedded }">
    <!-- embedded：透传给 CustomizedChinaMap，嵌入大屏三栏时不再强制 860px 最小高度 -->
    <chart
      height="100%"
      width="100%"
      :embedded="embedded"
      :path="path1"
      :id="id1"
      :params="params1"
    />
  </div>
</template>

<script>
import Chart from '@/components/Charts/CustomizedChinaMap'

export default {
  name: 'CustomizeChinaMapChart',
  props: {
    path: {
      type: String
    },
    id: {
      type: String
    },
    height: {
      type: String
    },
    width: {
      type: String
    },
    params: {
    },
    /**
     * 是否嵌入窄容器（大屏中间栏等）：为 true 时地图根节点填满父级且不强制 min-height:860px
     */
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      path1: this.path,
      id1: this.id,
      height1: this.height,
      width1: this.width,
      params1: this.params,
    }
  },
  components: {Chart}
}
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
}

/* 地图组件根节点拉满包裹层（CustomizedChinaMap 单根节点） */
.chart-container > * {
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
}

/**
 * embedded（仅大屏 centerMap）：父级 .centerMap 为 flex:1 时已有确定高度，本层拉满并允许子项 min-height:0 参与 flex。
 * 无确定父高时仍有 CustomizedChinaMap 内联最小高度兜底（若将来复用到别处）。
 */
.chart-container--embedded {
  flex: 1 1 0;
  min-height: 0;
  height: 100%;
  width: 100%;
}
</style>
